import { clientInitial } from '@/configuration/clientConf';
import cloneDeep from 'lodash/cloneDeep';

export default function preparationClientToUpdate(dataClient) {
  const client = cloneDeep(clientInitial);
  delete client.adresse;
  client.adressePostale = {
    adresse1: dataClient.adrLibelle1,
    adresse2: dataClient.adrLibelle2,
    adresse3: dataClient.adrLibelle3,
    latitude: dataClient.latitude,
    longitude: dataClient.longitude,
    ville: dataClient.adrVille,
    pays: dataClient.adrPays,
    codePostal: dataClient.adrCp,
    intitule1: dataClient.adrIntitule1,
    intitule2: dataClient.adrIntitule2,
    intitule3: dataClient.adrIntitule3,
  };
  client.nomCommercial = dataClient.nomCommercial;
  client.nomJuridique = dataClient.nomJuridique;
  client.siret = dataClient.siret;
  client.siren = dataClient.siren;
  client.secteurActiviteId = dataClient.secteurActiviteId;
  client.telephone = dataClient.telephone;
  client.email = dataClient.email;
  client.siteWeb = dataClient.siteWeb;
  client.contacts = dataClient.contacts;
  if (dataClient.modeReglement) {
    client.modeReglement = dataClient.modeReglement;
    client.modeReglementId = dataClient.modeReglement.id;
  }
  client.tiersParentId = dataClient.tiersParentId;
  client.marque = dataClient.marque;
  client.code = dataClient.code;
  client.id = dataClient.num;
  client.prospect = dataClient.prospect;
  client.applicationTva = dataClient.applicationTva;
  return client;
}



// WEBPACK FOOTER //
// ./src/services/client/preparationClientToUpdate.js